export interface TabsConfig {
    tabs: NodeListOf<HTMLElement>;
    content: NodeListOf<HTMLElement>;
}

export class Tabs {
    protected readonly elements: {
        tabs: NodeListOf<HTMLElement>;
        content: NodeListOf<HTMLElement>;
    };

    constructor({tabs, content}: TabsConfig) {
        this.elements = {tabs, content};
        this.init();
    }

    public switchTab(trigger: HTMLElement): number {
        let index = 0;
        this.elements.tabs.forEach((it, i) => {
            it.classList.remove(`is-active`);
            if (it === trigger) {
                it.classList.add(`is-active`);
                index = i;
            }
        });
        return index;
    }

    public switchContent(index: number): void {
        this.elements.content.forEach((it, i) => {
            it.classList.remove(`is-active`);
            if (i === index) it.classList.add(`is-active`);
        });
    }

    protected onTabClick(evt: Event): void {
        const trigger = evt.currentTarget as HTMLElement;
        const index = this.switchTab(trigger);
        this.switchContent(index);
    }

    protected onTabKeyPressing(evt: KeyboardEvent): void {
        if (evt.key === `Enter`) this.onTabClick(evt);
    }

    protected init(): void {
        const {tabs, content} = this.elements;
        if (!tabs.length || !content.length) return;
        tabs.forEach((tab) => {
            tab.addEventListener('click', (evt) => this.onTabClick(evt));
            tab.addEventListener('keydown', (evt) => this.onTabKeyPressing(evt));
        });
    }
}